import React from "react";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./TaskHeaderSmall.module.scss";

function TaskHeaderSmall(props) {
  const { isEnabled, title,
    closeTask,
    enableDragging, disableDragging,
    showNoControls, isMoveable } = props;
    
  const disabledOpacity = 0.7;

  const disabledStyle = {
    opacity: disabledOpacity
  }

  const renderHeaderButton = (icon, onClickHandler) => {
    return (
      <Button
        stylingMode={'text'}
        icon={icon}
        className={classes.titleButton}
        style={isEnabled ? null : disabledStyle}
        onClick={onClickHandler}
        disabled={!isEnabled}
      />
    );
  };

  const renderHeader = () => {
    return (
      <div className={cn(classes.taskHeaderSmall, 'dx-theme-accent-as-background-color')} onMouseOver={enableDragging} onMouseLeave={disableDragging} style={{ cursor: isMoveable ? "move" : "default" }}>
        <div />
        <div className={"ui-font-bold-1"} style={isEnabled ? null : disabledStyle}>
          {title}
        </div>
        {showNoControls
          ? <div />
          : renderHeaderButton('close', closeTask)
        }
      </div>
    );
  };

  return renderHeader();
}

export default TaskHeaderSmall;
